import { InfusePageView } from '@infuse/ui/layouts';
import { AppRouter } from '@infuse/ui/router';
import { Plugin } from 'vue';
import { UserDetailSlideIn, UserOverviewTab, UsersPage } from '@infuse/e-connector/user/pages';
import { BasicAuthenticator, useAuthenticator } from '@infuse/auth/services';
import { userPermissions } from '@infuse/api/e-connector/user';

export const UserFeaturePlugin: Plugin = {
  install() {
    const authenticator = useAuthenticator();
    if (!(authenticator instanceof BasicAuthenticator)) {
      return; // no user management for other auth types
    }

    AppRouter.addRoute('main', {
      path: '/users',
      component: InfusePageView,
      meta: {
        name: 'nav.users',
        icon: 'user',
        group: 'nav.nav-group.manage',
        permissionIds: [userPermissions.SEARCH]
      },
      children: [
        {
          path: '',
          name: 'users',
          component: UsersPage
        },
        {
          path: ':id',
          components: {
            default: UsersPage,
            slideIn: UserDetailSlideIn
          },
          children: [
            {
              path: '',
              redirect: {
                name: 'users.overview'
              }
            },
            {
              path: 'overview',
              name: 'users.overview',
              component: UserOverviewTab,
              meta: {
                type: 'tab',
                label: 'tabs.users.overview',
                permissionIds: [userPermissions.GET]
              }
            }
          ]
        }
      ]
    });
  }
};
